import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer'
import { TileLink } from '@/components/shared/components/Tile/variants/shared/TileLink'
import Heading from '@/components/typography/Heading'
import type { GridCardProps } from '@/types/general'
import { TileIcon } from './shared/TileIcon'

export function IntegrationsWithDescriptionCard({ icon, title, description, link }: GridCardProps) {
	return (
		<div className="flex flex-col p-4 md:p-6 w-full">
			<div className="flex flex-col">
				{icon && <TileIcon icon={icon} size="medium" />}

				<div className="flex flex-col items-start text-left mt-4 md:mt-6">
					{title && (
						<Heading tag="h3" fontSize="headingSmall" className="font-bold text-left">
							{title}
						</Heading>
					)}
				</div>
			</div>

			<div className="relative">
				{description && (
					<CkEditorCSRRenderer
						className="mt-2 text-brand-black text-left"
						variant="textOnly"
						htmlContent={description}
					/>
				)}
				{link && (
					<TileLink
						className="gap-1 mt-4 md:mt-2 static opacity-100 pointer-events-auto"
						link={link}
					/>
				)}
			</div>
		</div>
	)
}
